mutation UpdateTimecodes($id: ID!, $input: UpdateTimecodesInput!) {
  updateTimecodes(id: $id, input: $input) {
    id
    timecodes {
      id
      type
      time
      title
      description
      icon
      duration
      position
      linkedContent {
        id
        title
        preview {
          id
          url(format: SMALL)
        }
      }
    }
    updatedAt
  }
}
